import React, { useMemo } from 'react';
import { AccountBalance } from '../services/account/types';
import { useTransactionGridContext } from '../transaction/TransactionGridContext';
import { TransactionEntity } from '../transaction';
import { formatCurrency } from '../common/utils';
import { ClockIcon } from '../icons';


interface BalanceCardsProps {
    balanceInfo: AccountBalance;
    onCashOut?: () => void;
}

const BalanceCards = ({ balanceInfo, onCashOut }: BalanceCardsProps) => {
    const { transactions } = useTransactionGridContext();
    const pendingTxCount = useMemo(() => (transactions?.filter(
            item => item.xTransactionEntity === TransactionEntity.IMPACT)
        ?? []).length, [transactions]);

    return (
        <div className="balance-row">
            {/* Cash */}
            <div className={'balance-card tokens cashout-ready'}>
                <div className="card-eyebrow">Available Cash</div>
                <div className="balance-value">{formatCurrency(balanceInfo.cash)}</div>
                <div className="balance-sub">Earned from activity</div>
                <div className="cashout-footer">
                    { (balanceInfo.pending?.debit ?? 0) > 0 &&
                        <div className="cashout-pending">
                            <ClockIcon/>
                            <span>Awaiting Withdrawal</span>
                            <span className="cashout-pending-amount">-{formatCurrency(balanceInfo.pending.debit)}</span>
                        </div>
                    }
                    <button className="cashout-btn" onClick={onCashOut}>
                        Cash out
                    </button>
                </div>
            </div>

            {/* Pending Credit */}
            <div className={'balance-card credit'}>
                <div className="card-eyebrow">Awaiting Deposit</div>
                <div className="balance-value">{formatCurrency(balanceInfo.pending?.credit ?? 0)}</div>
                <div className="balance-sub">Pending confirmation</div>
                { pendingTxCount > 0 &&
                    <div className="balance-badge badge-pending">
                        ● {pendingTxCount} transactions
                    </div>
                }
            </div>
        </div>
    );
}

export default BalanceCards;